import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import Icon from "@material-ui/core/Icon";
import {uid} from "react-uid";
import ContextMenu from "./TabsComponent/ContextMenu";
import {ScreenDesignerContextNew} from "../../../../../../../ContextComponents/ScreenDesignerContextNew";

const initialContextState = {
    mouseX: null,
    mouseY: null,
};
const navItemSource = {
    type: 'navigationItem',
    properties: {label: "Nav Item", icon: ''}
};
const BottomMenuComponent = (props) => {
    const {
        component = {},
        path
    } = props;
    const {
        onDeleteComponent,
        onSelectComponent,
        onDropComponent
    } = useContext(ScreenDesignerContextNew);
    const [isOpenContext, setIsOpenContext] = useState({event: initialContextState, item: {}});
    const [activeNavItem, setActiveNavItem] = useState(0);
    const {styles: sourceStyles, children = [], properties} = component;
    const styles = sourceStyles ? sourceStyles[0] : {};

    function openContext(event, source, index) {
        event.stopPropagation();
        event.preventDefault();
        setIsOpenContext({
            event: {
                mouseX: event.clientX - 2,
                mouseY: event.clientY - 4,
            },
            item: {
                index,
                source
            }
        });
    }

    function closeContext() {
        setIsOpenContext({
            event: initialContextState,
            item: {index: null, source: null}
        });
    }

    function onEdit() {
        onSelectComponent(isOpenContext.item.source, `${path}.children.${isOpenContext.item.index}`)
    }

    function onRemove() {
        onDeleteComponent(`${path}.children.${isOpenContext.item.index}`, isOpenContext.item.source.type,)
    }

    function addAfter() {
        onDropComponent(navItemSource, isOpenContext.item.index + 1, `${path}.children`)
    }

    function addBefore() {
        onDropComponent(navItemSource, isOpenContext.item.index, `${path}.children`)
    }

    function onSelectNavItem(source, index) {
        onSelectComponent(source, `${path}.children.${index}`)
    }

    return (
        <div style={{...styles}}>
            <BottomNavigation
                showLabels={properties.showLabels}
                onChange={(e, v) => setActiveNavItem(v)}
                value={activeNavItem}
            >
                {children.map((item, index) => (
                    <NavigationItem
                        key={uid(item)}
                        item={item}
                        index={index}
                        openContext={openContext}
                        onSelectNavItem={onSelectNavItem}
                    />
                ))}
            </BottomNavigation>
            <ContextMenu
                onClose={closeContext}
                anchorEl={isOpenContext.event}
                index={isOpenContext.item.index}
                itemsCount={children.length}
                addAfter={addAfter}
                addBefore={addBefore}
                remove={onRemove}
                edit={onEdit}
            />
        </div>
    )
};

export default BottomMenuComponent;

BottomMenuComponent.propTypes = {
    component: PropTypes.object,
};


const NavigationItem = (props) => {
    const {item: {properties = {}} = {}, openContext, onSelectNavItem} = props;
    return (
        <BottomNavigationAction
            {...props}
            onClick={(e) => {
                e.stopPropagation();
                onSelectNavItem(props.item, props.index)
            }}
            onContextMenu={(e) => openContext(e, props.item, props.index)}
            label={properties.label}
            icon={<Icon>{properties.icon}</Icon>}
        />
    )
};
NavigationItem.propTypes = {
    item: PropTypes.object
};